// Version : 0.0.3
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : REMOVED UNWANTED REDUX
// MODFIED DATA : 07-12-2025

const GoldLoanArrearReportTypes = {
	/************* FETCH GOLD LOAN ARREAR REPORT DETAILS START *********** */
	GET_GOLDLOAN_ARREAR_REPORT_START: 'get_gold_loan_arrear_update_log_report_start',
	GET_GOLDLOAN_ARREAR_REPORT_SUCCESS: 'get_gold_loan_arrear_report_details_success',
	GET_GOLDLOAN_ARREAR_REPORT_FAILURE: 'get_gold_loan_arrear_report_details_failure',
	GET_GOLDLOAN_ARREAR_REPORT_RESPONSE_RESET: 'get_gold_loan_arrear_report_details_response_reset',
	GET_GOLDLOAN_ARREAR_REPORT_RESPONSE_CHANGED:
		'get_gold_loan_arrear_report_details_response_changed',
	/************* FETCH GOLD LOAN ARREAR REPORT DETAILS END *********** */
};
export default GoldLoanArrearReportTypes;
